export { getDecodedConsulData } from './getDecodedConsulData'
